import { Env, OurContext } from '../../context';
import { FailureReason } from '../../generated-sources/payments-api';

export enum ErrorType {
  PAYMENT_FAILED,
  TIMEOUT,
  UNKNOWN,
}

export interface ErrorState {
  type: ErrorType;
  title: string;
  message: string;
}

export interface ErrorDetails {
  type: ErrorType;
  failureReason?: FailureReason;
  devMessage?: string;
}

export function mapError(
  { type, failureReason, devMessage }: ErrorDetails,
  context: OurContext
): ErrorState | null {
  let message = context.texts['error.message.unknown'];

  if (type == ErrorType.PAYMENT_FAILED) {
    // Set default failure reason as invalid card
    message = context.texts['fscp.error.message.invalidCard'];
  }

  if (failureReason) {
    switch (failureReason) {
      case FailureReason.InsufficientFunds:
        message = context.texts['fscp.error.message.insufficientFunds'];
        break;
      case FailureReason.InvalidCard:
      case FailureReason.CountryNotAllowed:
      case FailureReason.CreditNotAllowed:
        message = context.texts['fscp.error.message.invalidCard'];
        break;
    }
  }

  if ([Env.DEV, Env.UAT].includes(context.env) && devMessage) {
    message = message + '\n' + devMessage;
  }

  return { type, message, title: getTitle(context, type) };
}

function getTitle(context: OurContext, type: ErrorType): string {
  switch (type) {
    case ErrorType.PAYMENT_FAILED:
      return context.texts['fscp.error.payment-failed'];
    case ErrorType.TIMEOUT:
      return context.texts['fscp.error.timeout'];
    case ErrorType.UNKNOWN:
    default:
      return context.texts['fscp.error.unknown'];
  }
}
